// extracted by mini-css-extract-plugin
export default {"root":"Cookies_root__rbnKp"};